import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { journalTypeOptions } from '@/module/Nomen/JournalType/model/JournalTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type JournalTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function JournalTypeSelectControl<T extends FieldValues>(props: JournalTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(journalTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
